import type { DeepPartial } from '@luna/utils-ts';

import type { Search } from '../../types/Search';

export const searchSKFeatureConfig: DeepPartial<Search> = {
    countryProductId: 'Securities',
    displayIssuerForShares: true,
    extraGroupTypeKeys: ['PREMIUM_DEPOSIT'],
    fetchDocuments: true,
    showPreorderScreenOnSuggestionClick: true,
};
